import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;


export const addAgent = createAsyncThunk(
  "agents/addAgent",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/agents/create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage = responseDataError.error || "Произошла ошибка";
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
      }

      const responseData = await response.json();
      const { access_token, agent_id } = responseData;
      toast.success("Агент успешно добавлен!");
      return { access_token, agent_id };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const fetchAgents = createAsyncThunk(
  "agents/fetchAgents",
  async (token, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/agents`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage = responseDataError.error || "Произошла ошибка";
        return rejectWithValue(errorMessage);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAgentById = createAsyncThunk(
    "agents/getAgentById",
    async ({ id, token }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/api/v1/agents/${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const responseDataError = await response.json();
                const errorMessage = responseDataError.error || "Ошибка при получении данных агента";
                return rejectWithValue(errorMessage);
            }

            const data = await response.json();
            return data.agent; // возвращаем конкретного агента
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updateAgent = createAsyncThunk(
    "agents/updateAgent",
    async ({ id, updatedData, token }, { rejectWithValue, dispatch  }) => {
        try {
            const response = await fetch(`${API_URL}/api/v1/agents/${id}`, {
                method: "PATCH",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: updatedData,
            });

            if (!response.ok) {
                const responseDataError = await response.json();
                const errorMessage = responseDataError.error || "Ошибка при обновлении агента";
                return rejectWithValue(errorMessage);
            }
            toast.success("Данные успешно обновлены!");
            dispatch(fetchAgents(token));
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const deleteAgent = createAsyncThunk(
    "agents/deleteAgent",
    async ({ id, token }, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_URL}/api/v1/agents/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const responseDataError = await response.json();
                const errorMessage = responseDataError.error || "Ошибка при удалении агента";
                return rejectWithValue(errorMessage);
            }

            toast.success("Агент успешно удалён!");
            return id; // возвращаем id удалённого агента
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



const agentsSlice = createSlice({
  name: "agents",
  initialState: {
    agents: [],
    agent: null,
    status: null,
    error: null,
    loading: false,
    access_token: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
   
      .addCase(addAgent.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addAgent.fulfilled, (state, action) => {
        state.status = "succeeded";

        if (!Array.isArray(state.agents)) {
          state.agents = [];
        }
        state.agents.push(action.payload);
        state.access_token = action.payload.access_token;
      })
      .addCase(addAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })


      .addCase(fetchAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
    .addCase(getAgentById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.agent = null;
    })
    .addCase(getAgentById.fulfilled, (state, action) => {
        state.loading = false;
        state.agent = action.payload;
    })
    .addCase(getAgentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(updateAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(updateAgent.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.agent = action.payload;
    })
    .addCase(updateAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(deleteAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(deleteAgent.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = state.agents.filter((agent) => agent.id !== action.payload);

        // Если удалён агент, который был открыт в модалке, очищаем agent
        if (state.agent && state.agent.id === action.payload) {
            state.agent = null;
        }
    })
    .addCase(deleteAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

  },
});

export default agentsSlice.reducer;
